import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFlowPageStyle } from './styled';
import FBOButton from 'ui/theme/components/FBOButton/FBOButton';
import { useNavigate } from 'react-router-dom';

export interface FBOFlowCardProps {
  title: string;
  description: string;
  link: string;

  dataQa?: string;
}

export const FBOFlowCard: React.FC<FBOFlowCardProps> = (props) => {
  const { link, description, title, dataQa } = props;

  const classes = useFlowPageStyle();
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      className={classes.redesignFlowCard}
    >
      <FBOButton
        variant="tertiary"
        color="positive"
        size="medium"
        data-qa={`${dataQa}-link`}
        onClick={() => navigate(link)}
      >
        {title}
      </FBOButton>
      <Typography className={classes.redesignFlowCardDescription}>
        {description}
      </Typography>
    </Box>
  );
};
